import { createAction } from "redux-actions";
import * as types from "./types";

export const setCurrentPage = createAction(types.SET_CURRENT_PAGE);
export const setCurrentView = createAction(types.SET_CURRENT_VIEW);
